<h1 mat-dialog-title>Obexto Mes fichiers</h1>
<div mat-dialog-content>Une mise à jour de l'application est disponible, voulez-vous l'installer ?</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuler</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Installer</button>
</mat-dialog-actions>